export default {
  "pl": {
    "constants": {
      "address": {
        "city": "Miasto",
        "country": "Kraj",
        "number": "Numer",
        "street": "Ulica",
        "zip": "Kod pocztowy"
      },
      "days": [
        "Niedz.",
        "Pon.",
        "Wt.",
        "Śr.",
        "Czw.",
        "Pt.",
        "Sob."
      ],
      "languages": {
        "de": "niemiecki",
        "en": "angielski",
        "fallback_info": "Wygląda na to, że ta wiadomość nie jest dostępna w Twoim języku. Zamiast tego używamy istniejącego tłumaczenia {fallback_locale}.",
        "fr": "francuski",
        "nl": "niderlandzki",
        "pl": "polskie"
      },
      "measurements": {
        "imperial": "Imperialny",
        "metric": "Metryczny",
        "surface": {
          "imperial": "ft2",
          "metric": "m2",
          "null": ""
        }
      },
      "months": [
        "Styczeń",
        "Luty",
        "Marzec",
        "Kwiecień",
        "Maj",
        "Czerwiec",
        "Lipiec",
        "Sierpień",
        "Wrzesień",
        "Październik",
        "Listopad",
        "Grudzień"
      ],
      "profile_statuses": {
        "active": "Aktywny",
        "added": "Nie zaproszono",
        "blocked": "Nieaktywny",
        "discarded": "Deleted",
        "invited": "Zaproszono",
        "invited_at": "Zaproszono"
      },
      "profile_statuses_descriptive": {
        "active": "Ostatnia aktywność na platformie: {session_ended_at}",
        "added": "Nie zaproszono",
        "blocked": "Nieaktywny",
        "discarded": "Deleted",
        "invited": "Wysłano zaproszenie, ale użytkownik jeszcze się nie zarejestrował",
        "invited_at": "Wysłano zaproszenie o {invited_at}, ale użytkownik jeszcze się nie zarejestrował"
      },
      "profile_titles": {
        "dr": "Doktor",
        "mr": "Pan",
        "mrs": "Pani",
        "professor": "Profesor",
        "sirmadam": "–"
      },
      "time_units": {
        "days": "Dni",
        "months": "Miesiące",
        "weeks": "Tygodnie"
      },
      "time_units_count": {
        "days": "brak dnia | dzień | dni",
        "months": "brak miesiąca | miesiąc | mies.",
        "weeks": "brak tygodnia | tydzień | tyg."
      },
      "timezones": {
        "Europe/Brussels": "(GMT+01:00) Europa/Bruksela",
        "Europe/Lisbon": "(GMT+00:00) Europa/Lizbona",
        "Europe/London": "(GMT+00:00) Europa/Londyn",
        "Europe/Madrid": "(GMT+01:00) Europa/Madryt"
      },
      "wind_orientations": {
        "east": "Wschód",
        "north": "Północ",
        "northeast": "Północny wschód",
        "northwest": "Północny zachód",
        "select": "Wybierz orientację",
        "south": "Południe",
        "southeast": "Południowy wschód",
        "southwest": "Południowy zachód",
        "west": "Zachód"
      }
    }
  }
}
